// Auth routes
export const LOGIN = "/connexion";

// App routes - Espace Agent
export const ESPACE_TCA = "/espace-tca";
export const NUMERISATION = "/espace-tca/numerisation";
export const DECISIONS = "/espace-tca/decisions";
export const RECHERCHE = "/espace-tca/recherche";
export const CONTROLE_QUALITE = "/espace-tca/controle-qualite";
export const DECISIONS_INTERNES = "/espace-tca/decisions-internes";
export const JURISPRUDENCE_NATIONALE = "/espace-tca/jurisprudence-nationale";

// App routes - Espace Admin
export const ESPACE_ADMIN = "/espace-admin";
export const ADMIN_UTILISATEURS = "/espace-admin/utilisateurs";
export const ADMIN_HISTORIQUE = "/espace-admin/historique";
